/* @flow */
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { style, $, media } from 'glamor';

import LocaleSwitcher from '../LocaleSwitcher';
import Container from 'depop/components/layout/Container';
import Link from 'depop/components/Link';


export default class Footer extends React.Component {
  render() {
    return (
      <nav {...style({
        display: 'none',
      })} {...media('(min-width: 701px)', {
        display: 'block',
        position: 'fixed',
        bottom: 0,
        width: '100%',
        margin: 0,
        background: '#fff',
        zIndex: 10,
      })}>
        <Container>
          <ul {...style({
            display: 'inline-block',
            margin: '0 auto',
            listStyleType: 'none',
          })} {...$('> li', {
            display: 'inline-block',
            marginRight: '1em',
            fontSize: 14,
          })} {...$('> li a', {
            color: 'inherit',
            textDecoration: 'none',
            fontWeight: 'bold',
            cursor: 'pointer',
          })} {...$('> li:hover a', {
            textDecoration: 'underline',
          })}>
            <li><Link to={{pathname: '/about/'}}>
              <FormattedMessage
                id="app.aboutLabel"
                description="About Label"
                defaultMessage="About"
              />
            </Link></li>
            <li><Link to={{pathname: '/about/jobs/'}}>
              <FormattedMessage
                id="app.jobsLabel"
                description="Jobs Label"
                defaultMessage="Jobs"
              />
            </Link></li>
            <li>
              <a rel="noopener" target="_blank" href="http://blog.depop.com/">
                <FormattedMessage
                  id="app.blogLabel"
                  description="Blog Label"
                  defaultMessage="Blog"
                />
              </a>
            </li>
            <li>
              <a rel="noopener" target="_blank" href="http://help.depop.com/">
                <FormattedMessage
                  id="app.supportLabel"
                  description="Support Label"
                  defaultMessage="Support"
                />
              </a>
            </li>
            <li><a rel="noopener" target="_blank" href="https://instagram.com/depop/">Instagram</a></li>
            <li><a rel="noopener" target="_blank" href="https://twitter.com/depop/">Twitter</a></li>
            <li><a rel="noopener" target="_blank" href="https://facebook.com/depop">Facebook</a></li>
            <li><LocaleSwitcher /></li>
          </ul>
        </Container>
      </nav>
    );
  }
}



// WEBPACK FOOTER //
// ../src/client/components/layout/footer/Footer.js